

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class SubjectCommunicationAttatchments {
  public subject_file?: number | 0;
  public job_file?: number;
  public file_name?: string;


  // ? what does this really do? (no encoding or deserialisation required...)
   /*deserialize(input: any): SubjectCommunicationAttatchments {
    Object.assign(this, input);

    return this;
  }
*/

}

  // Set the Stats
